export default "__VITE_ASSET__XavSSNTN__ 400w, __VITE_ASSET__CPX2GNSY__ 800w, __VITE_ASSET__DYYv$PMZ__ 1024w";